import request from "./request";

const api = {
  sendCode: "code/sendCode",
  sendSafetyCode: "code/sendSafetyCode",
  sendUpdateCode: "code/sendUpdateCode",
  checkCode: "code/checkCode",
};
export default {
  sendCode(parameter) {
    return request({
      url: api.sendCode,
      method: "POST",
      data: parameter,
    });
  },
  checkCode(parameter) {
    return request({
      url: api.checkCode,
      method: "POST",
      data: parameter,
    });
  },
  sendSafetyCode(parameter) {
    return request({
      url: api.sendSafetyCode,
      method: "POST",
      data: parameter,
    });
  },
  sendUpdateCode(parameter) {
    return request({
      url: api.sendUpdateCode,
      method: "POST",
      data: parameter,
    });
  },
};
